import React, { useState } from "react";
import PropTypes from "prop-types";
import { Modal, ModalBody, ModalFooter, Button } from "reactstrap";
import i18n from "../../../i18n";
import { delEmployeesAdminDelete } from "../../../helpers/api_rombo_helper";
import SimpleAlertError from "../../../components/Alerts/SimpleAlertError";

const DeleteModal = ({ isOpen, toggle, setDeleteModal, setShowAlertSuccess, setTextHeader, setTextBody, selectedEmployee, setSelectedEmployee, setReloadEmployee, reloadEmployee, token }) => {

  const [errorAlert, setErrorAlert] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState(null);

  function onClickSave() {
    let body  = {
      ids: [{ id: selectedEmployee.id, status: "DELETED" }]
    }
    delEmployeesAdminDelete(token, body)
      .then((response) => {
        setDeleteModal(false)
        setShowAlertSuccess(true)
        setReloadEmployee(!reloadEmployee)
        setSelectedEmployee({})
        setTextHeader(i18n.t("DeletedEmployee"))
        setTextBody(i18n.t("SuccessDeletedEmployee"))
      })
      .catch((error) => {
        console.error("Error - delEmployeesAdminDelete ", error)
        setErrorAlertMessage((error.response?.data?.detail || error.message))
        setErrorAlert(true)
      })
  }
  
  return (
    <Modal
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="RequestModal"
      tabIndex="-1"
      toggle={toggle}
      backdrop={'static'}
      id="staticBackdrop"
      size={"lg"}
    >
      <div>
        <p className="cancellation-title">{i18n.t("DeleteEmployee")}</p>
        <div className="modal-separator" />
        <ModalBody className="mt-0 pt-0">
          <SimpleAlertError errorAlert={errorAlert} setErrorAlert={setErrorAlert} text={errorAlertMessage} />
          <div className="delete-modal-content">
            <p className="delete-modal-consequence">
              <i className="mdi mdi-information-outline" />
              {i18n.t("TextDeleteEmployee")}
            </p>      
            <div className="delete-modal-employee-card">
              <div className="delete-modal-employee-avatar">
                <span className="delete-modal-employee-initials">
                  {selectedEmployee.name ? selectedEmployee.name.charAt(0).toUpperCase() : "U"}
                </span>
              </div>
              <div className="delete-modal-employee-info">
                <h4 className="delete-modal-employee-name">{selectedEmployee.name}</h4>
                <p className="delete-modal-employee-email">{selectedEmployee.email}</p>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            className="btn-users border"
            type="button"
            onClick={onClickSave}
          >
            {i18n.t("Accept")}
          </Button>
          <Button
            className="btn-light"
            type="button"
            data-dismiss="modal"
            onClick={toggle}
          >
            {i18n.t("GoBack")}
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  )
}

DeleteModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  setDeleteModal: PropTypes.func,
  setShowAlertSuccess: PropTypes.func,
  setTextHeader: PropTypes.func,
  setTextBody: PropTypes.func,
  selectedEmployee: PropTypes.shape,
  setReloadEmployee: PropTypes.func,
  reloadEmployee: PropTypes.bool,
  token: PropTypes.object,
  setSelectedEmployee: PropTypes.func
}

export default DeleteModal;
